import { Box, Image, Text } from "dssp-ui-lib";
import { useLocation } from "react-router-dom";
import { UseJsxT } from "./functions/i18n/LanguageFormatter";

export const ErrorPage = () => {
    const location = useLocation();
    const { errorCode } = location?.state ?? {};

    const errorCodeHandling = (errorCode) => {
        if (errorCode === "SESSION-40404") {
            return ` [NET0001]`;
        } else if (errorCode === "Core-50000" || errorCode === "Could not reach the server." || errorCode === "10001") {
            return ` [NET0003]`;
        } else {
            return ` [${errorCode}]`;
        }
    };

    return (
        <Box
            className={
                "rds-h-screen xs:rds-bg-[#F1F1F1] lg:rds-bg-red-120 rds-font-body rds-flex rds-flex-col rds-overflow-hidden"
            }
        >
            <Box
                className={
                    "rds-bg-[rgba(255,255,255,1)] rds-rounded-t-3xl rds-overflow-hidden rds-flex-1 rds-min-h-0 xs:rds-mt-0 lg:rds-mt-0"
                }
            >
                <Box className={"rds-relative rds-flex rds-h-full rds-min-h-0 rds-flex-col rds-overflow-y-auto"}>
                    <Box
                        className={
                            "rds-flex rds-flex-1 rds-flex-col rds-items-center rds-justify-center rds-px-16 rds-text-center"
                        }
                    >
                        <Image
                            name={"system-downtime"}
                            className={"rds-mb-2 rds-h-auto rds-w-[200px] md:rds-w-[200px] lg:rds-w-[200px]"}
                        />
                        <Text
                            size={"xl"}
                            bold
                            className={
                                "rds-mb-xs rds-text-center rds-text-neutral-100 md:rds-text-[28px] md:rds-leading-[36px]"
                            }
                        >
                            <UseJsxT k="ui.error.title" />
                        </Text>
                        <Text
                            size={"sm"}
                            className={
                                "rds-max-w-[320px] rds-text-center rds-text-neutral-80 rds-leading-[20px] md:rds-max-w-[420px] md:rds-text-[16px] md:rds-leading-[24px]"
                            }
                        >
                            <UseJsxT
                                k="ui.error.message"
                                options={{ errorCode: errorCode ? errorCodeHandling(errorCode) : "" }}
                            />
                        </Text>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
